import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTwitter, faLinkedinIn, faGithub } from "@fortawesome/free-brands-svg-icons"
import './styles.scss'
import GridBg from "../../gridBg/gridBg"

function BoardMember({ boardInfo, boardImage }) {
  return (<>
    <div className="d-flex flex-row justify-content-between flex-xl-column">
      <div className="board-image">
        <Img fluid={boardImage.childImageSharp.fluid} />
      </div>
      <div className="board-person">
        <div className="title">{boardInfo.title}</div>
        <div className="name">{boardInfo.name}</div>
        <ul className="d-flex justify-content-center mt-4">
          {!!boardInfo.twitter && (
            <li className="board-social-icon">
              <a
                href={boardInfo.twitter}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faTwitter} size="2x" />
              </a>
            </li>
          )}

          {!!boardInfo.github && (
            <li className="board-social-icon">
              <a href={boardInfo.github} target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faGithub} size="2x" />
              </a>
            </li>
          )}

          {!!boardInfo.linkedin && (
            <li className="board-social-icon">
              <a href={boardInfo.linkedin} target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faLinkedinIn} size="2x" />
              </a>
            </li>
          )}
        </ul>
      </div>
    </div>
    <div className="board-person-description">{boardInfo.description}</div>
  </>)
}

const CompanyBoard = (props) => {
  return (
    <StaticQuery
      query={graphql`
        query {
          allDataYaml {
            edges {
              node {
                top {
                  board {
                    heading
                    members {
                      ceo {
                        title
                        name
                        twitter
                        github
                        linkedin
                        description                     
                      }
                      cto {
                        title
                        name
                        twitter
                        github
                        linkedin
                        description                     
                      }                     
                      coo {
                        title
                        name
                        twitter
                        github
                        linkedin
                        description                     
                      }
                    }
                  }
                }
                language
              }
            }
          }
          ceoImage: file(relativePath: {eq: "top/board/ceo.png"}) {
            name
            childImageSharp {
              fluid(maxWidth: 224) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          ctoImage: file(relativePath: {eq: "top/board/cto.png"}) {
            name
            childImageSharp {
              fluid(maxWidth: 224) {
                ...GatsbyImageSharpFluid
              }
            }
          }         
          cooImage: file(relativePath: {eq: "top/board/coo.png"}) {
            name
            childImageSharp {
              fluid(maxWidth: 224) {
                ...GatsbyImageSharpFluid
              }
            }
          }         
        }
      `}
      render={({ allDataYaml: { edges }, ceoImage, ctoImage, cooImage}) => {
        const { language } = props
        const { node: { top: { board } } } = edges.find(({node}) => node.language === language)
        const { heading, members } = board

        return <div className="top-board">
          <h2>{heading}</h2>
          <div className="board-member-container">
            <ul className="d-flex flex-column flex-xl-row justify-content-xl-between">
              <li className="board-member">
                <BoardMember boardInfo={members.ceo} boardImage={ceoImage} />
              </li>
              <li className="board-member">
                <BoardMember boardInfo={members.cto} boardImage={ctoImage} />
              </li>
              <li className="board-member">
                <BoardMember boardInfo={members.coo} boardImage={cooImage} />
              </li>
            </ul>
          </div>
          <div className="skew-section-line d-none d-xl-block">
            <GridBg color="gray" topBgColor="gray" bottomBgColor="white" />
          </div>
        </div>
      }}
    />
  )
}



export default CompanyBoard;
